import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Typography, Card, CardContent, Tooltip } from "@mui/material";
import {
  white,
  borderGrayLight,
  darkDenium,
  valueBlack,
} from "../../constants/colors";
import { StatusCard } from "./DashboardStyles";
import { OUTCOME_LABELS } from "./DashboardConstants";

import { ReactComponent as InfoIcon } from "../../assets/InfoIconLucy.svg";

const OutreachOutcomeSummary = ({ outcomes, loading, onOutcomeClick }) => {
  const displayOutcomes = useMemo(() => {
    if (loading) {
      return Object.entries(OUTCOME_LABELS).map(([, label]) => ({
        label,
        count: "-",
        color: null,
        subReasons: [],
      }));
    }
    if (outcomes && outcomes.length > 0) {
      return outcomes;
    }
    return Object.entries(OUTCOME_LABELS).map(([, label]) => ({
      label,
      count: "-",
      color: null,
      subReasons: [],
    }));
  }, [outcomes, loading]);

  return (
    <Card
      sx={{
        borderRadius: "12px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        height: "100%",
        minHeight: "320px",
        bgcolor: white,
      }}
    >
      <Box
        sx={{
          height: "50px",
          px: "20px",
          display: "flex",
          alignItems: "center",
          borderBottom: `1px solid ${borderGrayLight}`,
        }}
      >
        <Typography
          sx={{ fontWeight: 500, fontSize: "16px", color: darkDenium }}
        >
          Outreach Outcome Summary
        </Typography>
      </Box>
      <CardContent
        sx={{
          p: "16px !important",
          height: "calc(100% - 60px)",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: "12px",
          }}
        >
          {displayOutcomes.map((item, idx) => (
            <StatusCard
              key={item.label}
              color={item.color}
              onClick={() => {
                const hasSubReasons =
                  item.subReasons && item.subReasons.length > 0;
                if (
                  (item.label === "Member Declined" ||
                    item.label === "Not Enrolled") &&
                  hasSubReasons
                ) {
                  onOutcomeClick(item);
                }
              }}
              sx={{
                cursor:
                  (item.label === "Member Declined" ||
                    item.label === "Not Enrolled") &&
                  item.subReasons &&
                  item.subReasons.length > 0
                    ? "pointer"
                    : "default",
              }}
            >
              <Tooltip title={item.label} arrow placement="top">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    maxWidth: "75%",
                    overflow: "hidden",
                  }}
                >
                  <Typography
                    noWrap
                    sx={{
                      fontWeight: 500,
                      fontSize: "13px",
                      color: valueBlack,
                      textOverflow: "ellipsis",
                    }}
                  >
                    {item.label}
                  </Typography>
                  {(item.label === "Member Declined" ||
                    item.label === "Not Enrolled") && (
                    <InfoIcon
                      style={{
                        width: 14,
                        height: 14,
                        marginLeft: 4,
                        flexShrink: 0,
                      }}
                    />
                  )}
                </Box>
              </Tooltip>
              <Typography
                sx={{ fontWeight: 700, fontSize: "16px", color: darkDenium }}
              >
                {item.count}
              </Typography>
            </StatusCard>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

OutreachOutcomeSummary.propTypes = {
  outcomes: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      color: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
  onOutcomeClick: PropTypes.func.isRequired,
};

export default OutreachOutcomeSummary;
